import type { ContainerModuleLoader } from '@wix/thunderbolt-ioc'
import { ViewerManagerByRefApi } from './viewerManagerByRefApi'
import { ViewerManagerApiImplementor } from 'thunderbolt-viewer-manager-types'
import { ModelUpdatesHandlersImplementor } from 'ds-feature-model-updates-invoker'
import { byRefResolvingDoneChecker } from './byRefResolvingDoneChecker'
import { ByRefResolvingDoneSymbol } from './symbols'
import { DataRequirementsCheckerSymbol } from '@wix/thunderbolt-symbols'

export { ByRefResolvingDoneSymbol }

export const editor: ContainerModuleLoader = (bind) => {
	bind(ViewerManagerApiImplementor).to(ViewerManagerByRefApi)
	bind(ModelUpdatesHandlersImplementor, DataRequirementsCheckerSymbol, ByRefResolvingDoneSymbol).to(
		byRefResolvingDoneChecker
	)
}

export type { IByRefResolvingDone } from './types'
